var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_60883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 0H12C5.37258 0 0 5.37259 0 12V63C0 69.6274 5.37259 75 12 75H63C69.6274 75 75 69.6274 75 63V12C75 5.37258 69.6274 0 63 0Z",
    fill: "#FFC403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.339 33.0706V41.6352H30.9957V36.8325L29.4344 39.1465H28.2106L26.492 36.8325V41.6352H24.3445V33.0706H26.5058L28.9753 36.4291L31.1887 33.0706H33.339ZM34.0158 35.0105V33.0706H42.007V35.0105H39.2091V41.6352H36.8265V35.0105H34.0158ZM50.8186 33.0706V41.6352H48.8539L44.8296 36.741V41.6352H42.6838V33.0706H44.8167L48.6692 37.7956V33.0706H50.8186ZM37.4997 50.5794C30.5805 50.5794 24.06 49.2861 19.1402 46.9364C13.9936 44.4807 11.1582 41.1294 11.1582 37.5002C11.1582 33.8709 13.9936 30.5197 19.1402 28.0621C24.06 25.7124 30.5805 24.4209 37.4997 24.4209C44.4189 24.4209 50.9393 25.7142 55.8591 28.0639C61.0058 30.5197 63.8411 33.8718 63.8411 37.5002C63.8411 41.1285 61.0058 44.4807 55.8591 46.9383C50.9393 49.288 44.4189 50.5794 37.4997 50.5794ZM37.4997 26.3471C30.8622 26.3471 24.6372 27.5736 19.9716 29.8017C15.5329 31.9209 13.0881 34.6566 13.0881 37.5002C13.0881 40.3438 15.5329 43.0794 19.9716 45.1968C24.6363 47.4249 30.8622 48.6514 37.4997 48.6514C44.1372 48.6514 50.3622 47.4249 55.0277 45.1968C59.4664 43.0794 61.9113 40.3438 61.9113 37.5002C61.9113 34.6566 59.4664 31.9209 55.0277 29.8035C50.3622 27.5755 44.1372 26.3489 37.4997 26.3489V26.3471Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_60883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.bf51465cd54389cad2ef30b0c1659f63.svg";
export { ForwardRef as ReactComponent };